export class KullaniciGrupYetkiDuzenleRequest {

  kullaniciGrupId: number;
  yetkiIdListe: number[];

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
